import BaseComponentController from '../../../../components/base-component.controller';

class ManagementStrategyTextController extends BaseComponentController {
    constructor(_, componentRegistryService, $q, constants) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors:[]
        };
        this.managementStrategy = null;
        this.appendix3Link = constants.Links.Appendix3;
    }

    init() {
    }

    onManagementStrategyUpdated(selectedManagementStrategy) {
        this.managementStrategy = selectedManagementStrategy;
        this.onManagementStrategyRequired({ managementStrategyRequired: this.managementStrategy.managementStrategyRequired });
    }
}

ManagementStrategyTextController.$inject = ['_', 'componentRegistryService', '$q', 'constants'];

let managementStrategyTextComponent = {
    controller: ManagementStrategyTextController,
    bindings: {
        modelName:'@',
        managementStrategies: '<',
        onManagementStrategyRequired: '&',
        readonly: '<'
    },
    templateUrl:`app/assess/conflictOfInterest/components/management-strategy-text/management-strategy-text.html`
};

export default managementStrategyTextComponent;


// WEBPACK FOOTER //
// ./app/assess/conflictOfInterest/components/management-strategy-text/management-strategy-text.component.js